import React from "react";
import { makeStyles } from "tss-react/mui";
import ContextMenuItem from "./ContextMenuItem";
const useStyles = makeStyles()((theme) => {
    return {
        contextMenuItemGroup: {
            "&:not(:empty)": {
                padding: `${8} 0`,
            },
            "& + &:not(:empty)": {
                borderTop: `1px solid ${"#3D3D3D"}`,
            },
            "&:first-of-type": {
                paddingTop: 0,
            },
            "&:last-of-type": {
                paddingBottom: 0,
            },
        },
    };
});
const ContextMenuItemGroup = ({ actions, children }) => {
    const { classes: styles } = useStyles();
    return (React.createElement("div", { className: styles.contextMenuItemGroup },
        children, actions === null || actions === void 0 ? void 0 :
        actions.map((actionProps) => (React.createElement(ContextMenuItem, Object.assign({ key: actionProps.text }, actionProps))))));
};
export default ContextMenuItemGroup;
